import ApiService from '@services/api.service';
import { Notify } from 'quasar';

export const etudiantAbsences = {
  state: {
    etudiantAbsences: [],
    etudiantAbsence: null
  },
  mutations: {
    setEtudiantAbsences(state, absences) {
      state.etudiantAbsences = absences;
    },
    setEtudiantAbsence(state, absence) {
      state.etudiantAbsence = absence;
    }
  },
  actions: {
    fetchAbsencesByStudent(context, idStudent) {
      return ApiService.getRequest(`/etudiant_absences?etudiant=${idStudent}`).then(
        response => {
          this.commit('setEtudiantAbsences', response.data['hydra:member']);
          return response.data['hydra:member'];
        })
        .catch(error => { console.error(error) });
    },
    //  paramètres obligatoires : etudiantId (Number) / dt_start (format: YYYY-MM-DD) / dt_end (format: YYYY-MM-DD) / hr_start (format: HH:mm:ss) / hr_end (format: HH:mm:ss)
    fetchAbsenceByStudentAndDates(context, data) {
      let properties = ['etudiantId', 'dt_start', 'dt_end', 'hr_start', 'hr_end'];
      let isValid = false;
      if (data && properties.every(propName => data[propName] !== null && data[propName] !== undefined)) {
        isValid = true;
      }

      if (isValid === true) {
        let uri = '/etudiant_absences?';
        uri += `etudiant.id=${data.etudiantId}`;
        uri += `&dt_start=${data.dt_start}`;
        uri += `&dt_end=${data.dt_end}`;
        uri += `&hr_start=${data.hr_start}`;
        uri += `&hr_end=${data.hr_end}`;
        return ApiService.getRequest(uri)
          .then(
            response => {
              this.commit('setEtudiantAbsence', response.data['hydra:member'][0]);
              return response.data['hydra:member'][0];
            })
          .catch(error => { console.error(error) });
      } else {
        //  paramètres obligatoires : etudiantId (Number) / dt_start (format: YYYY-MM-DD) / dt_end (format: YYYY-MM-DD) / hr_start (format: HH:mm:ss) / hr_end (format: HH:mm:ss)
        throw new Error('Invalid parameters.');
      }

    },
    //  ajout d'une absence à un stagiaire
    async addEtudiantAbsence({ state, dispatch }, data) {
      try {
        const response = await ApiService.postRequest('/etudiant_add_absence', data);
        if (response.data) {
          //Réupere le pointage par l' id absence, puis par l'id etudiant + id emargement
          const pointageAbsence = await dispatch('fetchPointagesByAbsenceId', response.data.id);

          if(pointageAbsence.length === 0){
            let dataPointage = {
              etudiant: data.etudiant,
              emargement: data.emargement
            }
            const pointagePresence = await dispatch("fetchPointageByEtudiantEmargement", dataPointage);

            if(pointagePresence.length === 0){
              let formData = new FormData();
              formData.append('etudiant', data.etudiant);
              formData.append('raison', data.raison);
              formData.append('dt_start', data.dt_start);
              formData.append('dt_end', data.dt_end);
              formData.append('hr_start', data.hr_start);
              formData.append('hr_end', data.hr_end);
              formData.append('etudiant_id', data.etudiant_id);
              formData.append('absence_id', response.data.id);
              formData.append('antenne_id', data.antenne);
              formData.append("emargement", data.emargement);

              let dataAbsence = {
                form: formData,
                etudiant_id: data.etudiant_id,
                emargement: data.emargement
              }
              dispatch('addEtudiantPointageAbsence', dataAbsence);
            }
            else {
              let dataPointage = {
                dt_start: data.dt_start,
                dt_end: data.dt_end,
                hr_start: data.hr_start,
                hr_end: data.hr_end,
                raison: data.raison,
                etudiant: data.etudiant,
                absence_id: response.data.id,
                pointage_id: pointagePresence[0].id,
                emargement: data.emargement,
                typepointage: "absence"
              }
              await dispatch('updatePointageAbsence', dataPointage);
            }
          }
          Notify.create({
            message: "L'absence a été créée avec succès.",
            color: "green"
          });
          return Promise.resolve();
        }
      } catch (error) {
        console.error(error)
        Notify.create({
          message: "Une erreur s'est produite",
          color: "red"
        })
        return Promise.reject(error);
      }
    },
    // Ajoute l'abscence d'un stagiaire
    async addAbsence(context, formData){
      try{
        const response = await ApiService.postRequest('etudiant_absences', formData);
        context.commit('setEtudiantAbsence', response.data);

        Notify.create({
          message: "Abscence ajoutée avec succès",
          color: "green"
        })
      }catch(error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite lors de l'ajout de l'absence",
          color: 'red'
        })
      }
    },
    //Modifie l'absence séléctionnée
    async updateAbsence(context, data){
      try{
        const response = await ApiService.postRequest(data.url, data.formData);
        context.commit('setEtudiantAbsence', response.data);

        Notify.create({
          message: "L'absence à été modifiée avec succès",
          color: 'green'
        })
      }catch(error){
        console.error(error);
        Notify.create({
          messsage: "Un erreur s'est produite lors de la modification de l'absence",
          color: 'red'
        })
      }
    }
    //todo: delete absence
  },
  getters: {
    getEtudiantAbsences(state) {
      return state.etudiantAbsences;
    },
    getEtudiantAbsence(state) {
      return state.etudiantAbsence;
    }
  }
}
